import React, { PureComponent } from 'react';
import { Select, Table, Button, Pagination, MessageBox, Message } from 'element-react';
import './application.css'
import Http from "../../networkReq/http"
import { Link } from 'react-router-dom';
import Request from "../../networkReq/request";
import { getToken, getCurrentUser } from 'utils/storage';
export default class Application extends PureComponent {

    state = {
        citys: [],
        selectCitys: [],
        value: '',
        areaValue: '',
        pageSize: 10,
        provinceId: '',
        cityId: '',
        countyId: '',
        city: [{
            value: '三亚市',
            label: '三亚市'
        }, {
            value: '海口市',
            label: '海口市'
        }, {
            value: '三沙市',
            label: '三沙市'
        }, {
            value: '儋州市',
            label: '儋州市'
        }, {
            value: '五指山市',
            label: '五指山市'
        }, {
            value: '文昌市',
            label: '文昌市'
        }, {
            value: '琼海市',
            label: '琼海市'
        }, {
            value: '万宁市',
            label: '万宁市'
        }, {
            value: '东方市',
            label: '东方市'
        }],
        value: '',
    };

    toApplicationProcess = (data) => {
        console.log(data)
        // if (type == 1) {
        //     this.props.history.push('/preferential/applicationProcess')
        // } else {
        //     MessageBox.alert('您的档案不存在，无法办理！', '提示');
        // }
        let token = getToken();
        if (token == null) {
            MessageBox.msgbox({
                title: "提示",
                message: "请先登录再在线办理！",
                showCancelButton: false,
                confirmButtonText: "关闭"
            });
        } else if (token != null) {
            // 获取档案信息，判断是否能进行在线办理
            Http.getApplication(Request.getArchivalInformation(), {}, obj => {
                console.log('obj', obj);
                if (obj.code == 200) {
                    this.props.history.push({ pathname: "/preferential/applicationProcess", state: { data } });
                } else {
                    Message.error(obj.msg);
                }
            });
        }
    }

    toApplicationGuide = (item) => {
        this.props.history.push('/preferential/applicationGuide?' + item.id)
    }

    componentDidMount() {
        this.getDynamicData(1);
        this.getAreaTree()
    }

    getAreaTree() {
        Http.get(Request.getAreaTree(), {}, obj => {
            console.log('getAreaTree', obj)
            if (obj && obj.code == 200) {
                const data = obj.data;
                this.setState({
                    citys: data,
                });
            }
        })

    }


    getDynamicData(current) {
        let { pageSize, provinceId, cityId, countyId } = this.state;
        let params = {
            size: pageSize,
            current: current,
            provinceId, cityId, countyId
        };
        Http.get(Request.getItemsList(), params, obj => {
            if (obj && obj.code == 200) {
                const data = obj.data;
                this.setState({
                    data: data,
                    currentPage: current
                });
            }
        })

    }


    onCurrentChange(currentPage) {
        this.getDynamicData(currentPage);

    }
    onSizeChange(currentSize) {
        this.setState({ pageSize: currentSize }, () => { this.getDynamicData(1); })
    }

    onChangeCity = (value, ) => {
        let length = value.length;
        this.setState({
            selectCitys: value,
            provinceId: length > 0 ? value[0] : '',
            cityId: length > 1 ? value[1] : '',
            countyId: length > 2 ? value[2] : '',
        }, () => this.getDynamicData(1))



    };

    render() {

        const {
            data, pageSize, value, city
        } = this.state;

        const columns = [
            {
                label: "事项名称",
                prop: "entitledName",
                width: 400,
                render: (row, column) => {
                    // return <Link to='/preferential/preferentialPolicyDetail'> <span style={{ color: '#18388c' }}>{row.entitledName}</span></Link>
                    return <div>{row.entitledName}</div>
                }
            },
            {
                label: "主管部门",
                prop: "entitledDepartment",
            },
            {
                label: "行政区划",
                prop: "administrator",
                render: (row, columns) => {
                    return <span>{row.cityName + row.countyName}</span>
                }
            },
            {
                label: "操作",
                width: 300,
                render: (data, columns) => {
                    return <span style={{ color: '#1181ea' }}><Button type="text" size="small" onClick={() => this.toApplicationProcess(data)}>在线办理</Button>
                        <Button style={{ marginLeft: '30px' }} type="text" size="small" onClick={() => this.toApplicationGuide(data)}>办事指南</Button>

                    </span>
                }
            }
        ];
        console.log('data', data)




        return (
            <div className="main_application" >
                <div className="main_application_center" >
                    <div className="center_search" >
                        <span style={{ color: '#18388c', fontSize: '24px', marginRight: '15px' }} > 优抚申请 </span>

                    </div>
                    <div style={{ marginTop: '30px' }}>
                        <span style={{ lineHeight: '24px', marginRight: '18px' }}> 海南省 </span>
                        <Select value={value} placeholder="请选择" style={{ marginRight: '9px' }}> {
                            city.map(el => {
                                return <Select.Option key={
                                    el.value
                                }
                                    label={
                                        el.label
                                    }
                                    value={
                                        el.value
                                    }
                                />
                            })
                        }
                        </Select>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <Table
                            style={{ width: '100%' }}
                            columns={columns}
                            data={data ? data.records : []}
                            border={true}
                        // onRowClick={this.onRowClick}
                        />

                    </div>

                    <div className="main_application">
                        {data ? <Pagination layout="total, sizes, prev, pager, next, jumper" total={data.total} pageSize={pageSize} currentPage={data.currentPage}
                            onCurrentChange={(val) => this.onCurrentChange(val)}
                            onSizeChange={(val) => this.onSizeChange(val)}
                        /> : null}

                    </div>

                </div>
            </div>

        )
    }
}